import { makeAutoObservable, runInAction } from "mobx";

export default class timeLineStore {
    timeLine = [];

  constructor() {
    makeAutoObservable(this);
  }

  setData = (data) => {
    this.timeLine = [];
    runInAction(() => {
      this.timeLine = data;
    });
  };

}
